import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_CHECK,
  AUTH_ERROR,
  AUTH_GET_PERMISSIONS
} from 'react-admin';
// import Raven from 'raven-js';

import { authUrl, authCheckUrl } from '../config';

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    // console.log('AUTH_LOGIN');
    const { username, password } = params;
    const formData = new FormData();
    formData.append('email', username);
    formData.append('password', password);

    const request = new Request(authUrl, {
      method: 'POST',
      body: formData,
      headers: new Headers({ Accept: 'application/json' }),
      credentials: 'include'
    });

    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error('Вы ввели неправильный Логин/Пароль');
        }
        return response.json();
      })
      .then(({ role, allowedComponents, token }) => {
        // Raven.setUserContext({
        //   login: username,
        //   role
        // });
        localStorage.setItem('token', token);
        localStorage.setItem('role', role);
        Promise.resolve();
      });
  }

  if (type === AUTH_GET_PERMISSIONS) {
    // console.log('AUTH_GET_PERMISSIONS');
    return Promise.resolve(localStorage.getItem('role'));
  }

  if (type === AUTH_LOGOUT) {
    // console.log('AUTH_LOGOUT');

    const request = new Request('/logout', {
      method: 'POST',
      headers: new Headers({ Accept: 'application/json' }),
      credentials: 'include'
    });

    return fetch(request).then(response => {
      if (response.status < 200 || response.status >= 300) {
        // console.log('AUTH_LOGOUT_NOT_OK');
        throw new Error(response.statusText);
      }
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      // console.log('AUTH_LOGOUT_OK');
      return Promise.resolve();
    });
  }

  if (type === AUTH_ERROR) {
    // console.log('AUTH_ERROR');
    const { status } = params;
    if (status === 401 || status === 403) {
      // console.log('AUTH_ERROR_REDIRECT_TO_LOGIN');
      // Raven.captureMessage('Auth error', { extra: params });
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      window.location = '#/login';
      return Promise.reject();
    }
    // console.log('AUTH_ERROR_DO_NOTHING');
    return Promise.resolve();
  }

  if (type === AUTH_CHECK) {
    // console.log('AUTH_CHECK');

    const request = new Request(authCheckUrl, {
      method: 'POST',
      headers: new Headers({ Accept: 'application/json' }),
      credentials: 'include'
    });

    return fetch(request).then(response => {
      if (response.status < 200 || response.status >= 300) {
        // console.log('AUTH_CHECK_NOT_OK');
        return Promise.reject();

        // throw new Error(response.statusText);
      }
      // console.log('AUTH_CHECK_OK');
      return Promise.resolve();
    });
  }

  return Promise.reject('Unkown method');
};



// WEBPACK FOOTER //
// ./src/providers/authClient.js